import React from 'react'
import { Centre } from '../../../types/centre'
import { GIFT_CARDS, PRODUCTS } from '../../paths'
import { LinkSectionPropsType, LinkSection } from './link-section'
import { CentreDetails } from './centre-details'
import style from './index.scss'

const sections: LinkSectionPropsType[] = [
  {
    heading: {
      text: 'Customer Support',
      url: 'https://support.westfield.com.au/hc/en-us',
    },
  },
  {
    heading: { text: 'Westfield Direct', url: '/' },
    links: [
      { text: 'About Westfield Direct', url: '/shop/info/' },
      { text: 'Click & Collect', url: '/shop/info/click-and-collect' },
      { text: 'Delivery', url: '/shop/info/delivery' },
      { text: 'Returns', url: '/shop/info/returns' },
      { text: 'Rewards', url: '/shop/info/rewards' },
      { text: 'Size guide', url: '/shop/info/size-guides' },
    ],
  },
  {
    heading: { text: 'Westfield Gift Cards', url: GIFT_CARDS },
    links: [
      {
        text: 'Gift Cards Terms & Conditions',
        url:
          '/terms-and-conditions#digital-gift-card-product-terms-and-conditions',
      },
    ],
  },
]

const findCentre = { text: 'Find a centre', url: '/' }
const productsHeading = { text: 'Products', url: PRODUCTS }

export const LeftColumnContainer: React.FC<{
  centre?: Centre
}> = ({ centre }) => (
  <div className={style.leftColumnContainer}>
    {centre ? (
      <CentreDetails centre={centre} />
    ) : (
      <LinkSection heading={findCentre} />
    )}
    {sections.map((section, index) => (
      <LinkSection
        heading={section.heading}
        links={section.links}
        key={index}
      />
    ))}
    {centre === undefined && <LinkSection heading={productsHeading} />}
  </div>
)
